/**
 * Formats a date for display in the UI
 */
export const formatDateForDisplay = (
  date: Date | string | null | undefined
): string => {
  if (!date) return "";
  const parsedDate = date instanceof Date ? date : new Date(date);
  if (isNaN(parsedDate.getTime())) return "";
  return parsedDate.toLocaleDateString();
};

/**
 * Determines a status based on start and end dates
 */
export const getStatusFromDates = (
  startDate: Date | string | null | undefined,
  endDate: Date | string | null | undefined
): string => {
  if (!startDate || !endDate) return "";

  const start = startDate instanceof Date ? startDate : new Date(startDate);
  const end = endDate instanceof Date ? endDate : new Date(endDate);
  const now = new Date();

  if (isNaN(start.getTime()) || isNaN(end.getTime())) return "";

  if (now < start) return "upcoming";
  if (now > end) return "expired";
  return "active";
};
